(function() {
  if (window.location.pathname.indexOf('/products/3x4-black-retro-prints') === -1) {
    return;
  }

  function buildBlackRetroSmartCropUrl(url) {
    if (!url) {
      return url;
    }

    var cleanUrl = url.split('?')[0].split('-/')[0];
    if (cleanUrl.charAt(cleanUrl.length - 1) !== '/') {
      cleanUrl += '/';
    }

    return cleanUrl + '-/preview/-/scale_crop/1200x1200/smart/-/format/jpeg/';
  }

  function applyBlackRetroSmartCrop(box) {
    if (!box || box.getAttribute('data-fp-smartcrop-applied') === 'true') {
      return;
    }

    var preview = box.querySelector('img.coaster_img');
    var fileUrl = box.querySelector('input.fileurl');
    var imageBox = box.querySelector('.imgbox');

    if (!preview || !fileUrl) {
      return;
    }

    var smartCropUrl = buildBlackRetroSmartCropUrl(fileUrl.value || preview.src);
    preview.src = smartCropUrl;
    fileUrl.value = smartCropUrl;

    if (imageBox) {
      imageBox.classList.remove('needcrop');
    }

    box.querySelectorAll('img.warning').forEach(function(warning) {
      warning.remove();
    });

    box.setAttribute('data-fp-smartcrop-applied', 'true');
  }

  $(document).ready(function() {
    // The legacy uploader checks this global before upload and again before cart.
    window.fileSizeLimit = function() {
      return true;
    };

    document.querySelectorAll('#uploadBox .box').forEach(applyBlackRetroSmartCrop);

    var uploadBox = document.getElementById('uploadBox');
    if (!uploadBox) {
      return;
    }

    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) {
            return;
          }

          if (node.matches && node.matches('.box')) {
            applyBlackRetroSmartCrop(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll('.box').forEach(applyBlackRetroSmartCrop);
          }
        });
      });
    }).observe(uploadBox, { childList: true, subtree: true });
  });
})();
